import React from 'react';
import { Alert, Row, Col, Icon } from 'antd';
import moment from 'moment';

/**
 * getDelay
 * Explanation of calcul: https://gitlab.makina-corpus.net/Terralego/Customers/onf-front/issues/182
 * @param {array} type of selected activity
 * @param {number} peopleCount
 * @returns {number} the number of days after now before a warning message is displayed
 */
function getDelay (type, peopleCount) {
  if (type.includes('shooting')) {
    return 15;
  }
  if (peopleCount >= 60 && peopleCount < 150) {
    return 45;
  }
  if (peopleCount >= 150 && peopleCount < 300) {
    return 60;
  }
  if (peopleCount >= 300) {
    return 90;
  }
  return 0;
}

/**
 * MessageEmergency
 * Display a message of emergency according to the type,
 * people's count, and dates of the selected activity.
 *
 * @param {Object} activity
 * @param {Object} dates
 * @returns {ReactElement} emergency message
 */
const MessageEmergency = ({ activity, dates }) => {
  const { type, participantCount, publicCount } = activity;
  const peopleCount = Number(participantCount) + Number(publicCount);

  if (!type || !peopleCount) {
    return null;
  }

  const earlierDate = dates.reduce(
    (acc, value) => Math.min(acc, moment(value.dates[0].startDate)),
    Infinity,
  );

  const delay = getDelay(type, peopleCount);
  const haveWarning = moment(earlierDate).subtract(delay, 'd').valueOf() < moment().valueOf();

  if (!haveWarning) {
    return null;
  }

  return (
    <Row gutter={24} style={{ paddingBottom: 12 }}>
      <Col span={24}>
        <Alert
          style={{ color: '#1b6fa3' }}
          message={(
            <React.Fragment>
              <Icon type="info-circle-o" /> Selon les informations que vous avez indiquées,
              votre déclaration d'activité devrait être réalisée minimum {delay} jours avant
              la date de l'événement. Vous avez tout de même la possibilité de déclarer cette
              activité en demandant un traitement d'urgence, celui-ci entraînant une
              sur-tarification au niveau de l'instruction. Pour plus d'informations, vous
              pouvez nous contacter par mail <a href={`mailto:autorisations.fontainebleau@onf.fr?subject=${encodeURIComponent("Demande d'information - Procédure d'urgence")}`}>autorisations.fontainebleau@onf.fr</a>.
            </React.Fragment>
          )}
          type="info"
        />
      </Col>
    </Row>
  );
};

export default MessageEmergency;



// WEBPACK FOOTER //
// ./src/components/FormDate/MessageEmergency.js